import React, { Component } from 'react';
import classNames from 'classnames'
import styles from './index.css';
//import PAA from '../../blocks/PhoneAndAddress';
import Title from '../../blocks/Title'
import MyIcons from '../../blocks/MyIcons'
import FooterMobile from '../../blocks/FooterMobile'
import {LangChangeEventContext} from '../../contexts/LangContext';

import AOS from 'aos/dist/aos.js'; 
import 'aos/dist/aos.css';

export default class Contacts extends Component {
  state={
    modelOpen: false,
    img    :''
  }
  componentWillMount(){
   
  }
  componentDidMount(){
    AOS.init({once:true, startEvent: 'DOMContentLoaded'});
  }
  render() {
    return (
      <LangChangeEventContext.Consumer>
        {({lang}) =>(
            <div className={classNames(styles['contactsBody'])} >  
              <div className={classNames(styles['backgroundImgWrapper'])}  
                data-aos="fade-up" data-aos-offset="50" data-aos-delay="0" 
                >  
                <img alt="" src={this.props.ADMIN_URL+this.props.data.bg} className={styles['backgroundImg']} /> 
              </div>
              

              <div className={classNames(styles['contentWrapper'])}  style={{transform:'translateY('+this.props.valueScroll+'px)'}}>
                <div className={classNames(styles['header'])} 
                  data-aos="fade-up" data-aos-offset="50"  data-aos-delay="200" 
                   >
                  <Title classStyle={styles['titleStyle']} colorStyle="black1"  title={lang.t('contactsHeader')} text={lang.t('contactsSubHeader')}/>
                </div>
                <div className={classNames(styles['content'])}>  
                  <div className={styles['wrapperText']} 
                    data-aos="fade-up" data-aos-offset="50" data-aos-delay="400" 
                  >  
                    
                    <div className={styles['block']} >
                      <h3 className={styles['wrapperTextTitle']} 
                        data-aos="fade-up" data-aos-offset="50"
                         >{lang.t('contactsAbout')}</h3>
                      <div className={styles['text']} >
                        <table className={styles['table']} 
                          data-aos="fade-up" data-aos-offset="50"
                          >
                          <thead> 
                            <tr>
                              <th className={styles['tableTH']}>{lang.t('contactsBreakfast')}</th>
                              <th className={styles['tableTH']}>{lang.t('contactsCards')}</th>                            
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className={classNames(styles['tableTD'],styles['tableTD_brek'])}>{lang.t('contactsBreakfastV')}</td>
                              <td className={styles['tableTD']}>{lang.t('contactsCardsV')}</td>                            
                            </tr>
                            </tbody>
                        </table>
                        <table className={styles['table']} 
                          data-aos="fade-up" data-aos-offset="50"
                          >
                          <thead>
                            <tr>
                              <th className={styles['tableTH']}>{lang.t('contactsDiscount')}</th>
                              <th className={styles['tableTH']}>{lang.t('contactsP')}</th>                            
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className={classNames(styles['tableTD'],styles['tableTD_disc'])}>{lang.t('contactsDiscountV')}</td>
                              <td className={styles['tableTD']}>{lang.t('contactsPV')}</td>                            
                            </tr>
                          </tbody>  
                        </table>
                        <table className={styles['table2']} 
                          data-aos="fade-up" data-aos-offset="50"
                          >
                          <thead>
                            <tr>                            
                              <th className={styles['tableTH']}>{lang.t('contactsLunch')}</th>
                              <th className={styles['tableTH']}>{lang.t('contactsKids')}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>                            
                              <td className={styles['tableTD']}>{lang.t('contactsLunchV')}</td>
                              <td className={styles['tableTD']}>{lang.t('contactsKidsV')}</td>
                            </tr>
                          </tbody>  
                        </table>
                      </div>
                      <div className={styles['spoon']} >  
                        <MyIcons icon="spoon" width="100px" height="100px"/>     
                      </div> 
                    </div>

                    <div className={styles['block']} >
                      <h3 className={styles['wrapperTextTitle2']} 
                        data-aos="fade-up" data-aos-offset="50"
                        >{lang.t('contactsInfo')}</h3>
                      <div className={styles['text2']}> 
                        <div className={classNames(styles['blockText'],styles['phoneMobile'])} 
                          data-aos="fade-up" data-aos-offset="50"
                          > 
                          {lang.t('contactsPhone')}<br/>
                          <a className={styles['phoneLink']} href={'tel:'+lang.t('contactsPhoneLink')}><h2 className={styles['phoneText']}>{lang.t('contactsPhoneV')}</h2></a>
                        </div>
                        <div className={styles['blockText']} 
                          data-aos="fade-up" data-aos-offset="50"
                          > 
                          {lang.t('contactsAddress')}<br/>
                          {lang.t('contactsAddressV')}
                        </div>
                        <div className={styles['blockText']} 
                          data-aos="fade-up" data-aos-offset="50"
                          > 
                          {lang.t('contactsMetro')}<br/>
                          {lang.t('contactsMetroV')}
                        </div>
                        <div className={styles['blockText']} 
                          data-aos="fade-up" data-aos-offset="50"
                          > 
                          {lang.t('contactsWorkTime')}<br/>
                          {lang.t('contactsWorkTimeV')}
                        </div>
                        <div className={classNames(styles['blockText'],styles['phone'])} 
                          data-aos="fade-up" data-aos-offset="50"  data-aos-delay="400" 
                          > 
                          {lang.t('contactsPhone')}<br/>
                          <a className={styles['phoneLink']} href={'tel:'+lang.t('contactsPhoneLink')}>{lang.t('contactsPhoneV')}</a>
                        </div>
                      </div>
                    </div>
                  </div>                    
                  
                  <div className={styles['galleryWrapper']} >  
                    {/* <img alt="" src="/assets/img/c-m.png" className={styles['galleryImg']} />     */}
                    
                  </div>  
                  <FooterMobile classStyle={styles.footerMobile} />
                </div>            
              </div>
            </div>
        )}
      </LangChangeEventContext.Consumer>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/ContactsMobile/index.js